import styled from 'styled-components'

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  gap: 20px;
`

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 68vw;
  max-width: 320px;

  @media (max-width: 460px) {
    max-width: 250px;
    font-size: 12px;
  }
`

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 8px 0;
`
export const SwitchArea = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 460px) {
    width: 100%;
  }
`

export const RecaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 460px) {
    transform: scale(0.72);
    transform-origin: center;
  }
`

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
